<script>
	/** @type {Specs} */
	export let specs;

	const specIconMap = {
		beds: "i-ph:bed-bold",
		baths: "i-ph:bathtub-bold",
		garage: "i-ph:garage-bold",
		area: "i-ph:square-half-bold",
	};

	let specData = [];
	$: if (specs) {
		specData = Object.entries(specs)
			.map(([k, v]) => {
				let value = v.toLocaleString();
				if (k === "area") value += ` ${specs.area_unit}`;
				return { icon: specIconMap[k], value };
			})
			.filter(({ icon }) => !!icon);
	}
</script>

<div class="flex flex-grow justify-between">
	{#each specData as s}
		<div class="flex gap-2 items-center border rounded-full px-3 py-1">
			<span class="{s.icon} text-xl" />
			<span class="whitespace-nowrap">{s.value}</span>
		</div>
	{/each}
</div>
